import { render, staticRenderFns } from "./DialogChangeArticleRanking.vue?vue&type=template&id=7a357022&scoped=true"
import script from "./DialogChangeArticleRanking.vue?vue&type=script&lang=js"
export * from "./DialogChangeArticleRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a357022",
  null
  
)

export default component.exports